declare namespace $ {

	type $mol_select__hint_shm_hitalama_codex_map_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_select['hint'] >
	>
	type $mol_select__value_shm_hitalama_codex_map_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_codex_map['agent_config'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__dictionary_shm_hitalama_codex_map_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_codex_map['agent_config_dictionary'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $shm_hitalama_resizer_side__resize_side_shm_hitalama_codex_map_4 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_resizer_side['resize_side'] >
	>
	type $shm_hitalama_resizer_side__width_shm_hitalama_codex_map_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_codex_map['width'] >
		,
		ReturnType< $shm_hitalama_resizer_side['width'] >
	>
	export class $shm_hitalama_codex_map extends $shm_codex_app {
		agent_config( next?: string ): string
		agent_config_dictionary( ): Record<string, any>
		Agent_config( ): $mol_select
		map_id( ): string
		sessions_page_visible( ): boolean
		width( next?: number ): number
		width_px( ): string
		Side_resizer( ): $shm_hitalama_resizer_side
		Sessions_icon( ): $mol_icon_chat
		chat_tools( ): readonly(any)[]
		style( ): ({ 
			'width': ReturnType< $shm_hitalama_codex_map['width_px'] >,
			'flexBasis': ReturnType< $shm_hitalama_codex_map['width_px'] >,
			'flexGrow': number,
			'flexShrink': number,
			'minWidth': string,
		})  & ReturnType< $shm_codex_app['style'] >
	}
	
}

//# sourceMappingURL=map.view.tree.d.ts.map